import potato from './potato';
export default {
  zh: {
    message: {
      ...potato,
      keyboard: {
        label: '键盘'
      }
    }
  }
};
